import { requestWithToken } from '../utilities/request';

const path = '/api/private/fields/';

const list = (fieldId, workId) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`${fieldId}/work_approvals/list`),
    params: {
      work_id: workId,
    },
  });
};

const workApproval = (
  fieldId,
  workIdList,
  firstName,
  lastName,
  bulkApprovalFlag = false
) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`${fieldId}/work_approvals/create_list`),
    data: {
      work_ids: workIdList,
      user_name_mei: firstName,
      user_name_sei: lastName,
      bulk_approval_flag: bulkApprovalFlag,
    },
  });
};

const destroy = (fieldId, workApprovalId) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`${fieldId}/work_approvals/destroy`),
    data: {
      work_approval_id: workApprovalId,
    },
  });
};

const cancelWorkApproval = (fieldId, workIdList) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`${fieldId}/work_approvals/destroy_list`),
    data: {
      work_ids: workIdList,
    },
  });
};

/**
 * @description 作業協力会社承認API
 * @param {number} fieldId 現場ID
 * @param {array} workIds 作業ID(配列)
 * @param {boolean} bulkApprovalFlag
 */
const partnerApproval = (fieldId, workIds, bulkApprovalFlag = false) => {
  return requestWithToken({
    method: 'POST',
    url: `/api/private/fields/${fieldId}/work_partner_company_approvals`,
    data: { work_ids: workIds, bulk_approval_flag: bulkApprovalFlag },
  });
};

/**
 * @description 作業協力会社承認取消API
 * @param {number} fieldId 現場ID
 * @param {array} workIds 作業ID(配列)
 */
const partnerDenial = (fieldId, workIds) => {
  return requestWithToken({
    method: 'DELETE',
    url: `/api/private/fields/${fieldId}/work_partner_company_approvals`,
    data: { work_ids: workIds },
  });
};

export const WorkApprovalService = {
  list,
  workApproval,
  destroy,
  cancelWorkApproval,
  partnerApproval,
  partnerDenial,
};

export default WorkApprovalService;



// WEBPACK FOOTER //
// ./src/services/WorkApprovals.js